<template>
    <div class="card">
        <div class="card-body">
            <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
                <!-- creditfixrr-letters -->
                <!-- <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 'creditfixrr-letters' }"
                        id="creditfixrr-letters"
                        data-toggle="tab"
                        href="#creditfixrr-letters"
                        @click="shiftTab('creditfixrr-letters')"
                        role="tab"
                        aria-controls="creditfixrr-letters"
                        aria-selected="true"
                    >
                        Creditfixrr Disputes
                    </a>
                </li> -->
                 <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 1 }"
                        id="data-furnisher-justified"
                        data-toggle="tab"
                        href="#data-furnisher"
                        @click="shiftTab(1)"
                        role="tab"
                        aria-controls="data-furnisher"
                        aria-selected="true"
                    >
                        Factual Disputes
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 2 }"
                        id="creditors-collection-agency-letters-justified"
                        data-toggle="tab"
                        href="#creditors-collection-agency-letters"
                        @click="shiftTab(2)"
                        role="tab"
                        aria-controls="creditors-collection-agency-letters"
                        aria-selected="true"
                    >
                        Furnishers & Debt Collectors
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 3 }"
                        id="credit-bureau-letters-justified"
                        data-toggle="tab"
                        href="#credit-bureau-letters"
                        @click="shiftTab(3)"
                        role="tab"
                        aria-controls="credit-bureau-letters"
                        aria-selected="true"
                    >
                        Credit Bureaus
                    </a>
                </li> -->
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 4 }"
                        id="metro-2-letters-justified"
                        data-toggle="tab"
                        href="#metro-2-letters"
                        @click="shiftTab(4)"
                        role="tab"
                        aria-controls="metro-2-letters"
                        aria-selected="true"
                    >
                        Metro-2 Disputes
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 5 }"
                        id="consumer-law-letters-justified"
                        data-toggle="tab"
                        href="#consumer-law-letters"
                        @click="shiftTab(5)"
                        role="tab"
                        aria-controls="consumer-law-letters"
                        aria-selected="false"
                    >
                        Consumer Law Disputes
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 6 }"
                        id="bankruptcy-letters-justified"
                        data-toggle="tab"
                        href="#bankruptcy-letters"
                        @click="shiftTab(6)"
                        role="tab"
                        aria-controls="bankruptcy-letters"
                        aria-selected="true"
                    >
                        Arbitration
                    </a>
                </li> -->
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 10 }"
                        id="custom-letters"
                        data-toggle="tab"
                        href="#custom-letters"
                        @click="shiftTab(10)"
                        role="tab"
                        aria-controls="custom-letters"
                        aria-selected="false">Custom Disputes
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 'all-letters' }"
                        id="all-letters"
                        data-toggle="tab"
                        href="#all-letters"
                        @click="shiftTab('all-letters')"
                        role="tab"
                        aria-controls="all-letters"
                        aria-selected="false">Other Disputes
                    </a>
                </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
                <div class="tab-pane active fade show" id="data-furnisher" role="tabpanel" aria-labelledby="data-furnisher-justified">
                    <!-- <div v-show="disputeCenterActiveTab == 2 && !isLoading" class="row mx-auto">
                        <div class="col-lg-3 col-md-3 col-12 mx-auto">
                            <a href="#" type="submit" data-toggle="modal" data-target="#round1_tutorial_modal_video"
                                class="btn-sm btn-outline-primary">
                                <i data-feather="film"></i>
                                Round-1 Dispute Flow Overview
                            </a>
                        </div>
                    </div>
                    <div v-show="disputeCenterActiveTab == 3 && !isLoading" class="row mx-auto">
                        <div class="col-lg-3 col-md-3 col-12 mx-auto">
                            <a href="#" type="submit" data-toggle="modal" data-target="#round2_tutorial_modal_video"
                                class="btn-sm btn-outline-primary">
                                <i data-feather="film"></i>
                                Round-2 Dispute Flow Overview
                            </a>
                        </div>
                    </div> -->
                    <!-- <div v-show="disputeCenterActiveTab == 4 && !isLoading" class="row mx-auto">
                        <div class="col-lg-3 col-md-3 col-12 mx-auto text-center">
                            <button type="button"  class="btn btn-outline-success" data-toggle="modal" data-target="#attack_modal">Attack Guide</button>
                        </div>
                    </div> -->
                    <dispute-attack id="attack_modal" />
                    <div v-if="isLoading || (typeof user.id == 'undefined')" class="text-center my-5">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else-if="disputeCenterActiveTab == 10">
                        <pagination :data="customLetters" @pagination-change-page="getCustomLetters" />
                        <div v-if="customLetters.data && customLetters.data.length > 0">
                            <Keep-alive>
                                <swiper
                                    :slides-per-view="4"
                                    :space-between="60"
                                    @swiper="onSwiper"
                                    @slideChange="onSlideChange"
                                    :navigation="true"
                                    :modules="modules"
                                    :pagination="{
                                        dynamicBullets: true,
                                        clickable: true,
                                    }"
                                    :breakpoints="{
                                        '1200': {
                                            slidesPerView: 4,
                                            spaceBetween: 60,
                                        },
                                        '991': {
                                            slidesPerView: 3,
                                            spaceBetween: 60,
                                        },
                                        '576': {
                                            slidesPerView: 2,
                                            spaceBetween: 60,
                                        },
                                        '0': {
                                            slidesPerView: 1,
                                            spaceBetween: 60,
                                        }
                                    }"
                                    class="grid-view px-5 mt-0"
                                >
                                    <swiper-slide v-for="(letter, index) in customLetters.data">
                                        <div class="card ecommerce-card">
                                            <div class="text-center">
                                                <img :src="letter?.media[0]?.original_url || settingStore.defaultBanner" class="img-fluid card-img-top" alt="img-placeholder" />
                                            </div>
                                            <div class="card-body p-50">
                                                <h6 class="item-name mt-0">
                                                    <a class="text-body" href="#">
                                                        {{ letter.name }}
                                                    </a>
                                                </h6>
                                            </div>
                                            <div class="item-options text-center" v-if="canEditLetter">
                                                <a class="btn btn-success btn-cart" @click="toggleEditor(letter.id)">
                                                    <i data-feather="edit"></i>
                                                    <span class="add-to-cart">Edit Letter</span>
                                                </a>
                                            </div>
                                            <template v-if="user.canCreateLetter">
                                                <div v-if="useStore.user?.isDIY || useStore.user?.isBusinessUser || !useStore.user?.isTeamMember" class="item-options text-center" style="background: transparent;">
                                                    <button @click="deleteLetter(letter.id)" class="btn btn-light btn-cart">
                                                        <i data-feather="trash"></i>
                                                        <span class="add-to-cart">Delete</span>
                                                    </button>
                                                    <router-link
                                                        :to="{ name: 'disputes-letter-edit', params: { letter: letter.id } }"
                                                        type="button"
                                                        class="btn btn-outline-primary btn-cart"
                                                        >
                                                            <i data-feather="edit"></i>
                                                            <span class="add-to-cart">Edit</span>
                                                    </router-link>
                                                </div>
                                                <div class="item-options text-center">
                                                    <router-link
                                                        v-if="useStore.user.isDIY !== true"
                                                        :to="{name: 'dispute-letter', params:{ letter: letter.slug, client:$route.params.client ? $route.params.client : null, team: $route.params.team ? $route.params.team : null }}"
                                                        type="button"
                                                        class="btn btn-primary btn-cart"
                                                    >
                                                        <i data-feather="file-text"></i>
                                                        <span class="add-to-cart">Create Letter</span>
                                                    </router-link>
                                                    <router-link
                                                        :to="{ name: 'dispute-letter', params: { letter: letter.slug } }"
                                                        type="button"
                                                        class="btn btn-primary btn-cart"
                                                        v-else
                                                        >
                                                            <i data-feather="file-text"></i>
                                                            <span class="add-to-cart">Create Letter </span>
                                                    </router-link>
                                                </div>
                                            </template>
                                            <div v-else class="item-options pro-plan text-center">
                                                <a :href="route('billing-plans', {})" type="button" class="btn btn-primary waves-effect waves-light btn-cart">
                                                    <span class="">Subscribe To A Plan</span>
                                                </a>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                </swiper>
                            </Keep-alive>
                        </div>
                        <p class="mt-3" v-else>{{ localizationStore.translate("form.letter.custom.not.letter") }}</p>
                    </div>
                    <div v-else-if="!isLoading && (disputeCenterActiveTab == 1 || disputeCenterActiveTab == 2 || disputeCenterActiveTab == 3 || disputeCenterActiveTab == 'creditfixrr-letters')">
                        <Keep-alive>
                            <template v-for="(agencies, heading) in letters[disputeCenterActiveTab]">
                                <h4 class="text-center text-primary py-2">
                                    {{ heading }}
                                </h4>
                                <template v-for="(letters, key_heading) in agencies">
                                    <swiper
                                        :slides-per-view="4"
                                        :space-between="60"
                                        @swiper="onSwiper"
                                        @slideChange="onSlideChange"
                                        :navigation="true"
                                        :modules="modules"
                                        :pagination="{
                                            dynamicBullets: true,
                                            clickable: true,
                                        }"
                                        :breakpoints="{
                                            '1200': {
                                                slidesPerView: 4,
                                                spaceBetween: 60,
                                            },
                                            '991': {
                                                slidesPerView: 3,
                                                spaceBetween: 60,
                                            },
                                            '576': {
                                                slidesPerView: 2,
                                                spaceBetween: 60,
                                            },
                                            '0': {
                                                slidesPerView: 1,
                                                spaceBetween: 60,
                                            }
                                        }"
                                        class="grid-view px-5 mt-0"

                                    >
                                        <swiper-slide v-for="(letter, index) in letters">
                                            <div class="card ecommerce-card">
                                                <div class="text-center">
                                                    <img class="img-fluid card-img-top" :src="letter.letter_image" alt="img-placeholder" />
                                                    <vue-feather
                                                        v-if="letter.letter_video"
                                                        width="28px"
                                                        height="28px"
                                                        type="play-circle"
                                                        class="play-icon"
                                                        @click="showModal(letter)"
                                                    ></vue-feather>
                                                </div>
                                                <div class="card-body p-50">
                                                    <h6 class="item-name mt-0">
                                                        <a class="text-body" href="#">
                                                            {{ letter.name }}
                                                        </a>
                                                    </h6>
                                                    <p class="card-text item-description mt-0">
                                                        {{ letter.short_description }}
                                                    </p>
                                                </div>
                                                <div class="item-options text-center" v-if="canEditLetter">
                                                    <a class="btn btn-success btn-cart" @click="toggleEditor(letter.id)">
                                                        <i data-feather="edit"></i>
                                                        <span class="add-to-cart">Edit Letter</span>
                                                    </a>
                                                </div>
                                                <div v-if="_.includes(comingSoonSlug, letter.slug)" class="item-options text-center">
                                                    <a href="#" class="btn btn-primary btn-cart">
                                                        <span class="add-to-cart">Coming Soon</span>
                                                    </a>
                                                </div>
                                                <div v-else-if="user.canCreateLetter" class="item-options text-center">
                                                    <!-- start -->
                                                    <router-link
                                                            :to="{ name: 'disputes-letter-tutorial', params: { letter: letter.slug } }"
                                                            type="button"
                                                            class="btn btn-light btn-wishlist"
                                                        >
                                                            <i data-feather="book"></i>
                                                            <span>Learn More</span>
                                                    </router-link>
                                                    <!-- end -->
                                                    <button
                                                        v-if="letter.type == letterStore.ATTACK"
                                                        @click="reportStore.createAttack(letter.slug, $event)"
                                                        type="button"
                                                        class="btn btn-primary btn-cart"
                                                    >
                                                        <vue-feather type="file-text" size="14" />
                                                        <span class="add-to-cart">Create Attack</span>
                                                    </button>
                                                    <span class="btn btn-primary btn-cart" v-else>
                                                        <router-link
                                                            v-if="useStore.user.isDIY !== true"
                                                            :to="{ name: 'dispute-letter', params: { letter: letter.slug, client:$route.params.client ? $route.params.client : null, team: $route.params.team ? $route.params.team : null}}"
                                                            type="button"
                                                            style="color:white"
                                                        >
                                                            <i data-feather="file-text"></i>
                                                            <span class="add-to-cart">Create Letter</span>
                                                        </router-link>
                                                        <router-link
                                                            :to="{ name: 'dispute-letter', params: { letter: letter.slug } }"
                                                            type="button"
                                                            style="color:white"
                                                            v-else
                                                            >
                                                                <i data-feather="file-text"></i>
                                                                <span class="add-to-cart">Create Letter </span>
                                                        </router-link>
                                                    </span>
                                                </div>
                                                <div v-else class="item-options text-center">
                                                    <a :href="route('billing-plans', {})" class="btn btn-primary btn-cart">
                                                        <span class="add-to-cart">Subscribe To A Plan</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    </swiper>
                                </template>

                            </template>
                        </Keep-alive>
                    </div>
                    <div v-else-if="!loading && disputeCenterActiveTab == 'all-letters'">
                        <Keep-alive>
                            <template v-for="(agencies, header) in letters[disputeCenterActiveTab]">
                                <h4 class="text-center text-primary py-2">
                                    {{ header }}
                                </h4>
                                <template v-for="(letters, heading) in agencies">
                                    <swiper
                                    :slides-per-view="4"
                                    :space-between="60"
                                    @swiper="onSwiper"
                                    @slideChange="onSlideChange"
                                    :navigation="true"
                                    :modules="modules"
                                    :pagination="{
                                        dynamicBullets: true,
                                        clickable: true,
                                    }"
                                    :breakpoints="{
                                        '1200': {
                                            slidesPerView: 4,
                                            spaceBetween: 60,
                                        },
                                        '991': {
                                            slidesPerView: 3,
                                            spaceBetween: 60,
                                        },
                                        '576': {
                                            slidesPerView: 2,
                                            spaceBetween: 60,
                                        },
                                        '0': {
                                            slidesPerView: 1,
                                            spaceBetween: 60,
                                        }
                                    }"
                                    class="grid-view px-5 mt-0"
                                >
                                    <swiper-slide v-for="(letter, index) in letters">
                                        <div class="card ecommerce-card">
                                            <div class="text-center">
                                                <img class="img-fluid card-img-top" :src="letter.letter_image" alt="img-placeholder" />
                                                <vue-feather
                                                    v-if="letter.letter_video"
                                                    width="28px"
                                                    height="28px"
                                                    type="play-circle"
                                                    class="play-icon"
                                                    @click="showModal(letter)"
                                                ></vue-feather>
                                            </div>
                                            <div class="card-body p-50">
                                                <h6 class="item-name mt-0">
                                                    <a class="text-body" href="#">
                                                        {{ letter.name }}
                                                    </a>
                                                </h6>
                                                <p class="card-text item-description mt-0">
                                                    {{ letter.short_description }}
                                                </p>
                                            </div>
                                            <div class="item-options text-center" v-if="canEditLetter">
                                                <a class="btn btn-success btn-cart" @click="toggleEditor(letter.id)">
                                                    <i data-feather="edit"></i>
                                                    <span class="add-to-cart">Edit Letter</span>
                                                </a>
                                            </div>
                                            <div v-if="_.includes(comingSoonSlug, letter.slug)" class="item-options text-center">
                                                <a href="#" class="btn btn-primary btn-cart">
                                                    <span class="add-to-cart">Coming Soon</span>
                                                </a>
                                            </div>
                                            <div v-else-if="user.canCreateLetter" class="item-options text-center">
                                                <!-- start -->
                                                <router-link
                                                        :to="{ name: 'disputes-letter-tutorial', params: { letter: letter.slug } }"
                                                        type="button"
                                                        class="btn btn-light btn-wishlist"
                                                    >
                                                        <i data-feather="book"></i>
                                                        <span>Learn More</span>
                                                </router-link>
                                                <!-- end -->
                                                <button
                                                    v-if="letter.type == letterStore.ATTACK"
                                                    @click="reportStore.createAttack(letter.slug, $event)"
                                                    type="button"
                                                    class="btn btn-primary btn-cart"
                                                >
                                                    <vue-feather type="file-text" size="14" />
                                                    <span class="add-to-cart">Create Attack</span>
                                                </button>
                                                <span class="btn btn-primary btn-cart" v-else>
                                                    <router-link
                                                        v-if="useStore.user.isDIY !== true"
                                                        :to="{ name: 'dispute-letter', params: { letter: letter.slug, client:$route.params.client ? $route.params.client : null, team: $route.params.team ? $route.params.team : null}}"
                                                        type="button"
                                                        style="color:white"
                                                    >
                                                        <i data-feather="file-text"></i>
                                                        <span class="add-to-cart">Create Letter</span>
                                                    </router-link>
                                                    <router-link
                                                        :to="{ name: 'dispute-letter', params: { letter: letter.slug } }"
                                                        type="button"
                                                        style="color:white"
                                                        v-else
                                                        >
                                                            <i data-feather="file-text"></i>
                                                            <span class="add-to-cart">Create Letter </span>
                                                    </router-link>
                                                </span>
                                            </div>
                                            <div v-else class="item-options text-center">
                                                <a :href="route('billing-plans', {})" class="btn btn-primary btn-cart">
                                                    <span class="add-to-cart">Subscribe To A Plan</span>
                                                </a>
                                            </div>
                                        </div>
                                        <!-- show metro 2 letter -->
                                        <div class="card ecommerce-card" v-if="_.toLower(header) == 'metro 2'">
                                            <div class="card ecommerce-card">
                                                <div class="text-center">
                                                    <img class="img-fluid card-img-top" :src="letter.letter_image" alt="img-placeholder" />
                                                    <vue-feather
                                                        v-if="letter.letter_video"
                                                        width="28px"
                                                        height="28px"
                                                        type="play-circle"
                                                        class="play-icon"
                                                        @click="showModal(letter)"
                                                    ></vue-feather>
                                                </div>
                                                <div class="card-body p-50">
                                                    <h6 class="item-name mt-0">
                                                        <a class="text-body" href="#">
                                                            {{ letter.name }}
                                                        </a>
                                                    </h6>
                                                    <p class="card-text item-description mt-0">
                                                        {{ letter.short_description }}
                                                    </p>
                                                </div>
                                                <div class="item-options text-center" v-if="canEditLetter">
                                                    <a class="btn btn-success btn-cart" @click="toggleEditor(letter.id)">
                                                        <i data-feather="edit"></i>
                                                        <span class="add-to-cart">Edit Letter</span>
                                                    </a>
                                                </div>
                                                <div v-if="_.includes(comingSoonSlug, letter.slug)" class="item-options text-center">
                                                    <a href="#" class="btn btn-primary btn-cart">
                                                        <span class="add-to-cart">Coming Soon</span>
                                                    </a>
                                                </div>
                                                <div v-else-if="onTrial && (disputeCenterActiveTab == 4 || disputeCenterActiveTab == 5 || disputeCenterActiveTab == 6)" class="item-options text-center">
                                                    <a :href="route('billing-plans', {})" class="btn btn-primary btn-cart">
                                                        <span class="add-to-cart">Upgrade Your Plan</span>
                                                    </a>
                                                </div>
                                                <div v-else-if="user.canCreateLetter" class="item-options text-center">
                                                    <router-link
                                                            :to="{ name: 'disputes-letter-tutorial', params: { letter: letter.slug } }"
                                                            type="button"
                                                            class="btn btn-light btn-wishlist"
                                                        >
                                                            <i data-feather="book"></i>
                                                            <span>Learn More</span>
                                                    </router-link>
                                                    <button
                                                        v-if="letter.type == letterStore.ATTACK"
                                                        @click="reportStore.letterSlug = letter.slug;openModal(`#${reportStore.bureauAddressModalId}`)"
                                                        type="button"
                                                        class="btn btn-primary btn-cart"
                                                    >
                                                        <i data-feather="file-text"></i>
                                                        <span class="add-to-cart">Select Address</span>
                                                    </button>
                                                    <!-- CHECK IF DIY -->
                                                    <span class="btn btn-primary btn-cart" v-else>
                                                        <router-link
                                                            v-if="useStore.user.isDIY !== true"
                                                            :to="{ name: 'dispute-letter', params: { letter: letter.slug, client:$route.params.client ? $route.params.client : null, team: $route.params.team ? $route.params.team : null}}"
                                                            type="button"
                                                            style="color:white"
                                                        >
                                                            <i data-feather="file-text"></i>
                                                            <span class="add-to-cart">Create Letter</span>
                                                        </router-link>
                                                        <router-link
                                                            :to="{ name: 'dispute-letter', params: { letter: letter.slug } }"
                                                            type="button"
                                                            style="color:white"
                                                            v-else
                                                            >
                                                                <i data-feather="file-text"></i>
                                                                <span class="add-to-cart">Create Letter </span>
                                                        </router-link>
                                                    </span>

                                                </div>
                                                <div v-else class="item-options text-center">
                                                    <a :href="route('billing-plans', {})" class="btn btn-primary btn-cart">
                                                        <span class="add-to-cart">Subscribe To A Plan</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- end of  metro 2 letter -->
                                    </swiper-slide>


                                    </swiper>
                                </template>
                            </template>
                        </Keep-alive>
                    </div>
                    <div v-else-if="!isLoading && disputeCenterActiveTab != 10 && disputeCenterActiveTab !== 'all-letters'">
                        <KeepAlive>
                            <swiper
                                :slides-per-view="4"
                                :space-between="60"
                                @swiper="onSwiper"
                                @slideChange="onSlideChange"
                                :navigation="true"
                                :modules="modules"
                                :pagination="{
                                    dynamicBullets: true,
                                    clickable: true,
                                }"
                                :breakpoints="{
                                    '1200': {
                                        slidesPerView: 4,
                                        spaceBetween: 60,
                                    },
                                    '991': {
                                        slidesPerView: 3,
                                        spaceBetween: 60,
                                    },
                                    '576': {
                                        slidesPerView: 2,
                                        spaceBetween: 60,
                                    },
                                    '0': {
                                        slidesPerView: 1,
                                        spaceBetween: 60,
                                    }
                                }"
                                class="grid-view px-5 mt-0"
                            >
                                <swiper-slide v-for="(letter, index) in  letters[disputeCenterActiveTab]">
                                    <div class="card ecommerce-card">
                                        <div class="text-center">
                                            <img class="img-fluid card-img-top" :src="letter.letter_image" alt="img-placeholder" />
                                            <vue-feather
                                                v-if="letter.letter_video"
                                                width="28px"
                                                height="28px"
                                                type="play-circle"
                                                class="play-icon"
                                                @click="showModal(letter)"
                                            ></vue-feather>
                                        </div>
                                        <div class="card-body p-50">
                                            <h6 class="item-name mt-0">
                                                <a class="text-body" href="#">
                                                    {{ letter.name }}
                                                </a>
                                            </h6>
                                            <p class="card-text item-description mt-0">
                                                {{ letter.short_description }}
                                            </p>
                                        </div>
                                        <div class="item-options text-center" v-if="canEditLetter">
                                            <a class="btn btn-success btn-cart" @click="toggleEditor(letter.id)">
                                                <i data-feather="edit"></i>
                                                <span class="add-to-cart">Edit Letter</span>
                                            </a>
                                        </div>
                                        <div v-if="_.includes(comingSoonSlug, letter.slug)" class="item-options text-center">
                                            <a href="#" class="btn btn-primary btn-cart">
                                                <span class="add-to-cart">Coming Soon</span>
                                            </a>
                                        </div>
                                        <div v-else-if="onTrial && (disputeCenterActiveTab == 4 || disputeCenterActiveTab == 5 || disputeCenterActiveTab == 6)" class="item-options text-center">
                                            <a :href="route('billing-plans', {})" class="btn btn-primary btn-cart">
                                                <span class="add-to-cart">Upgrade Your Plan</span>
                                            </a>
                                        </div>
                                        <div v-else-if="user.canCreateLetter" class="item-options text-center">
                                            <router-link
                                                    :to="{ name: 'disputes-letter-tutorial', params: { letter: letter.slug } }"
                                                    type="button"
                                                    class="btn btn-light btn-wishlist"
                                                >
                                                    <i data-feather="book"></i>
                                                    <span>Learn More</span>
                                            </router-link>
                                            <button
                                                v-if="letter.type == letterStore.ATTACK"
                                                @click="reportStore.letterSlug = letter.slug;openModal(`#${reportStore.bureauAddressModalId}`)"
                                                type="button"
                                                class="btn btn-primary btn-cart"
                                            >
                                                <i data-feather="file-text"></i>
                                                <span class="add-to-cart">Select Address</span>
                                            </button>
                                            <!-- CHECK IF DIY -->
                                            <span class="btn btn-primary btn-cart" v-else>
                                                <router-link
                                                    v-if="useStore.user.isDIY !== true"
                                                    :to="{ name: 'dispute-letter', params: { letter: letter.slug, client:$route.params.client ? $route.params.client : null, team: $route.params.team ? $route.params.team : null}}"
                                                    type="button"
                                                    style="color:white"
                                                >
                                                    <i data-feather="file-text"></i>
                                                    <span class="add-to-cart">Create Letter</span>
                                                </router-link>
                                                <router-link
                                                    :to="{ name: 'dispute-letter', params: { letter: letter.slug } }"
                                                    type="button"
                                                    style="color:white"
                                                    v-else
                                                    >
                                                        <i data-feather="file-text"></i>
                                                        <span class="add-to-cart">Create Letter </span>
                                                </router-link>
                                            </span>

                                        </div>
                                        <div v-else class="item-options text-center">
                                            <a :href="route('billing-plans', {})" class="btn btn-primary btn-cart">
                                                <span class="add-to-cart">Subscribe To A Plan</span>
                                            </a>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </KeepAlive>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div
        v-if="isPlayerActive"
        class="modal fade text-left show"
        tabindex="-1"
        aria-labelledby="myModalLabel17"
        aria-modal="true"
        role="dialog"
        style="padding-right: 15px;display:block;background: #000000b5;"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-lg"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleModal()">
                        <span aria-hidden="true" >×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="videoType == 1">
                        <iframe
                            v-if="videoUrl"
                            :src="videoUrl"
                            style="margin:auto;height: 66vh;width: 100%;"
                            width="560"
                            height="315"
                            :title="videoTitle"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div v-else>
                        <vue3-video-player
                            v-if="videoUrl"
                            :src="videoUrl"
                            :title="videoTitle"
                        ></vue3-video-player>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <edit-modal :openModal="editModalStatus" :canEdit="canEditLetter" :openModalMethod="toggleEditor" :letterdata="letterdata" :letterVideoType="videoType"/>
    <bureau-address-modal :id="reportStore.bureauAddressModalId" />
</template>
<style>
    .card .btn.btn-round-bottom {
        border-bottom-left-radius: calc(0.428rem - 1px);
        border-bottom-right-radius: calc(0.428rem - 1px);
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
    .card .btn.btn-round-bottom-left {
        border-bottom-left-radius: calc(0.428rem - 1px);
        border-bottom-right-radius: 0px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
    .card .btn.btn-round-bottom-right {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: calc(0.428rem - 1px);
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
    .play-icon {
        position: absolute;
        left: 50%;
        top: 35%;
        -webkit-transform:translate(-50%,-50%) ;
        -moz-transform:translate(-50%,-50%);
        -o-transform:translate(-50%,-50%);
        transform:translate(-50%,-50%);
        color: #ffffff;
        height: 50px;
        width: 50px;
        cursor:pointer;
        transition: color ease-in-out 0.5s;
        -webkit-transition: color ease-in-out 0.5s;
        -moz-transition: color ease-in-out 0.5s;
        -o-transition: color ease-in-out 0.5s;
    }
    .play-icon:hover{
        color: #4dc36a;
    }
</style>
<script>
    import { reactive, shallowRef, ref } from 'vue'
    import LaravelVuePagination from 'laravel-vue-pagination';
    import { useLocalizationStore } from '../stores/LocalizationStore.js';
    import { useReportStore } from '../stores/ReportStore.js'
    import { useLetterStore } from '../stores/LetterStore.js'
    import { useSettingStore } from '../stores/SettingStore.js'
    import { useUserStore } from '../stores/UserStore.js'
    import DisputeAttack from './modals/DisputeAttack.vue'
    import EditModal from './modals/EditModal.vue'
    import BureauAddress from './modals/BureauAddress.vue'
    import Swal from 'sweetalert2'
    import { openModal } from '../utilities/_helpers'
    import { Navigation, Pagination } from "swiper/modules";
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';
    import 'swiper/css/navigation';
    import 'swiper/css/pagination';
    import '../../css/base/plugins/extensions/ext-component-swiper.css';
    export default {
        props: {
        },
        components: {
            'pagination': LaravelVuePagination,
            DisputeAttack,
            EditModal,
            'bureau-address-modal': BureauAddress,
            Swiper,
            SwiperSlide
        },
        setup() {
            return {
                letters: shallowRef([]),
                editModalStatus:ref(false),
                letterdata:reactive({}),
                customLetters: reactive({}),
                disputeCenterActiveTab: ref(false),
                isLoading: ref(true),
                localizationStore: useLocalizationStore(),
                openModal: openModal,
                reportStore: useReportStore(),
                letterStore: useLetterStore(),
                settingStore: useSettingStore(),
                useStore: useUserStore(),
                user: reactive({}),
                isPlayerActive: ref(false),
                videoType: ref(null),
                videoTitle: ref(null),
                videoUrl: ref(null),
                comingSoonSlug: [
                    'request-an-investigation-attack',
                    'arbitration-1',
                    'notification-of-lawsuit-letter',
                    'failure-to-respond-within-15-days',
                ],
                _: _,
                modules: [Navigation, Pagination],
            }
        },
        mounted() {
            let userRoute = this.$router.resolve({
                name: 'user'
            });
            axios.get(userRoute.href)
            .then(response => {
                Object.assign(this.user, response.data.data.user);
            });
            let activeTab = localStorage.getItem('disputeCenterActiveTab')
            this.disputeCenterActiveTab = activeTab;
            this.reportStore.disputeCenterActiveTab = activeTab;
            this.disputeCenterActiveTab = (this.disputeCenterActiveTab == null) ? '1' : this.disputeCenterActiveTab;
            this.isLoading = true;
            if (this.disputeCenterActiveTab == 10) {
               this.getCustomLetters();
               return;
            }
            let route = this.$router.resolve({
                name: 'dispute-center-letters',
                params: {
                    type: this.disputeCenterActiveTab
                }
            });
            axios.get(route.href)
            .then(response => {
                this.letters[this.disputeCenterActiveTab] = response.data.data;
                this.isLoading = false;
            });
        },
        methods: {
            shiftTab(type) {
                localStorage.setItem('disputeCenterActiveTab', type);
                this.disputeCenterActiveTab = type;
                this.reportStore.disputeCenterActiveTab = type;
                if (
                    (typeof this.letters[this.disputeCenterActiveTab] == 'undefined')
                    ||
                    (this.letters[this.disputeCenterActiveTab].length < 1)
                ) {
                    this.isLoading = true;
                    if (this.disputeCenterActiveTab == 10) {
                       this.getCustomLetters();
                       return;
                    }
                    let route = this.$router.resolve({
                        name: 'dispute-center-letters',
                        params: {
                            type: type
                        }
                    });
                    axios.get(route.href)
                    .then(response => {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        this.letters[this.disputeCenterActiveTab] = response.data.data;
                        this.isLoading = false;
                    });
                }
            },
            getCustomLetters(page = 1) {
                let route = this.$router.resolve({
                    name: 'dispute-center-letters',
                    params: {
                        type: this.disputeCenterActiveTab
                    }
                });
                axios.get(route.href + '?page=' + page)
                .then(response => {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    Object.assign(this.customLetters, response.data);
                    this.isLoading = false;
                });
            },
            deleteLetter(letter) {
                const $this = this;
                Swal.fire({
                    title: 'Are you sure you want to delete a letter?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        let route = $this.$router.resolve({
                            name: 'disputes-letter-delete',
                            params: {
                                letter: letter
                            }
                        });
                        axios.delete(route.href)
                        .then(response => {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.getCustomLetters();
                            toastr.success(response.data.message, 'Success!');
                        });
                    }
                });
            },
            route(name, params) {
                if (this.$route.params && this.$route.params.client) {
                    params.client = this.$route.params.client
                    params.team = this.$route.params.team
                }
                let route = this.$router.resolve({
                    name: name,
                    params: params
                });
                return route.href;
            },
            toggleModal() {
                this.isPlayerActive = !this.isPlayerActive;
            },
            showModal(letter) {
                this.videoType = letter.video_type;
                this.videoTitle = letter.name;
                this.videoUrl = letter.letter_video;
                this.toggleModal();
            },
            toggleEditor(letter_id){
                if(this.editModalStatus == true){
                    this.editModalStatus = false
                }else{
                    let $this = this;
                    this.editModalStatus =true
                    axios.post('/disputes/editLetter',{letter_id}).then(({data})=>{
                        $this.letterdata = data.data
                        $this.letterStore.toEditLetterData = data.data
                        $this.letterVideoType = data.data.video_type
                    }).catch()
                }
            },
            // loaded() {
            //     this.isLoading = false;
            // }
            onSwiper(swiper){
            },
            onSlideChange(){
            }
        },
        computed: {
            isBusinessUser() {
                return this.user && this.user.isBusinessUser;
            },
            onTrial() {
                return this.user && this.user.onTrial;
            },
            canEditLetter(){
                return this.user && this.user.canEditAllLetter;
            }
        },
    }
</script>
